// extracted by mini-css-extract-plugin
export default {"login-container":"Login_login-container__pPTKX","container":"Login_container__5a6Xw","form-group":"Login_form-group__+4KgW","reset-password-form":"Login_reset-password-form__9wu9Z"};